import PropTypes from 'prop-types';
import { useCallback, useEffect } from 'react';
// routes
import { useRouter, useSearchParams } from 'src/routes/hooks';
import { paths } from 'src/routes/paths';
//
import { useSelector } from 'react-redux';
import { USER_TYPE_CONTRACTOR, USER_TYPE_SUPER_ADMIN } from 'src/config-global';
import { createPathAfterLogin } from 'src/utils/services';

// ----------------------------------------------------------------------

export default function GuestGuard({ children }) {
  const router = useRouter();

  const {user}=useSelector((state)=>state.user)
  const isLoggedIn = !!user?.accesstoken;
  const returnTo = user?.user_type === USER_TYPE_SUPER_ADMIN ? paths.superAdminDashboard.root : createPathAfterLogin(user);
  const check = useCallback(() => {
    if (isLoggedIn) {
      router.replace(returnTo);
    }
  }, [isLoggedIn, returnTo, router]);

  useEffect(() => {
    check();
  }, [check]);

  // Don't flash the login / register screen while redirecting a logged-in user.
  if (isLoggedIn) {
    return null;
  }

  return <>{children}</>;
}

GuestGuard.propTypes = {
  children: PropTypes.node,
};
